import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTabsModule } from '@angular/material/tabs';
import { MatToolbarModule } from '@angular/material/toolbar';
import { NgbCarouselModule } from '@ng-bootstrap/ng-bootstrap';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { RecaptchaModule } from 'ng-recaptcha';
import { CommonsModule } from '../../commons/commons.module';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';

import { CompanyNamesAnimationComponent } from './animations/company-names-animation/company-names-animation.component';
import { ConfirmAccountComponent } from './components/confirm-account/confirm-account.component';
import { SignInFlagComponent } from './components/flag/sign-in-flag.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { SignInPageComponent } from './components/sign-in-page/sign-in-page.component';
import { NewSignUpCardComponent } from './components/sign-up-card/new-sign-up-card.component';
import { VerifiedEmailPageComponent } from './components/verify-email/verified-email.component';
import { LandingComponent } from './landing/landing.component';
import { SigninRoutingModule } from './signin-routing.module';

@NgModule({
  declarations: [
    NewSignUpCardComponent,
    ConfirmAccountComponent,
    ForgotPasswordComponent,
    LandingComponent,
    CompanyNamesAnimationComponent,
    SignInPageComponent,
    SignInFlagComponent,
    VerifiedEmailPageComponent,
  ],
  imports: [
    CommonModule,
    SigninRoutingModule,
    CommonsModule,
    FormsModule,
    CoreModule,
    MatButtonModule,
    SharedModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    NgbCarouselModule,
    InfiniteScrollDirective,
    MatTabsModule,
    MatIconModule,
    MatCheckboxModule,
    MatToolbarModule,
    RecaptchaModule,
  ],
  exports: [SignInFlagComponent, NewSignUpCardComponent, ConfirmAccountComponent, ForgotPasswordComponent],
  providers: [],
})
export class SigninModule {}
